"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BosonSnapshotGate__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var BosonSnapshotGate__factory_1 = require("./BosonSnapshotGate__factory");
Object.defineProperty(exports, "BosonSnapshotGate__factory", {
  enumerable: true,
  get: function () {
    return BosonSnapshotGate__factory_1.BosonSnapshotGate__factory;
  }
});
